import React from 'react'

export default function SimpleValue({ value }) {
  return <div className={'re-value'}>{value}</div>
}
